"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var ThemeContext_1 = __importDefault(require("./ThemeContext"));

var ryerson = require("./assets/ryerson.json");

var ryersonApp = require("./assets/ryersonApp.json");

var southernToolSteel = require("./assets/southernToolSteel.json");

var checkFontsExist_1 = __importDefault(require("./checkFontsExist"));

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      defaultThemeName = _ref.themeName;
  var isMountedRef = (0, react_1.useRef)();

  var _ref2 = (0, react_1.useState)(true),
      _ref3 = _slicedToArray(_ref2, 2),
      init = _ref3[0],
      setInit = _ref3[1];

  var _ref4 = (0, react_1.useState)(defaultThemeName),
      _ref5 = _slicedToArray(_ref4, 2),
      themeName = _ref5[0],
      setThemeName = _ref5[1];

  var _ref6 = (0, react_1.useState)({
    ryerson: ryerson,
    ryersonApp: ryersonApp,
    southernToolSteel: southernToolSteel
  }),
      _ref7 = _slicedToArray(_ref6, 1),
      themes = _ref7[0];

  var _ref8 = (0, react_1.useState)(themes[themeName]),
      _ref9 = _slicedToArray(_ref8, 2),
      theme = _ref9[0],
      setTheme = _ref9[1];

  (0, checkFontsExist_1.default)();
  (0, react_1.useEffect)(function () {
    setInit(false);
  }, []);
  (0, react_1.useEffect)(function () {
    isMountedRef.current = true;

    if (isMountedRef.current && !init) {
      setTheme(themes[themeName]);
    }

    return function () {
      return isMountedRef.current = false;
    };
  }, [themeName]);
  return (0, jsx_runtime_1.jsx)(ThemeContext_1.default.Provider, {
    value: {
      theme: theme,
      themeName: themeName,
      setThemeName: setThemeName
    },
    children: children
  });
};

exports.default = ThemeProvider;